import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description}>
            ASSET MANAGEMENT CONSULTANCY SERVICE

          </h2>
          <h3>WHAT WE DO</h3>
          <h5>Our asset management consultancy service helps clients to develop strategy, create a framework for decision making, and provide information for property appraisals.
             The Asset Management area focuses its attention both on the optimization of daily operations and the maximization of revenues in order to optimize the value of real estate.
              The degree of dialogue reaches three levels: Asset & Corporation, Financial Institutions and Investors.
              
Optimise costs and continuously improve and innovate your property and asset management services through process improvement, deployment of platforms and systems to increase efficiency and changes to operating models.
Manage property & portfolio.Demand more from your real estate. Go beyond cost and risk mitigation.
If you have a range of properties and assets across different sectors, we can help you to get the best out of your investment.
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
